import React from "react"
import { Driver } from "@/types/drivers.types"
import Image from "next/image"
import { vehicleImage } from "@/utils/providers"
import OwnDriverNameAndStatus from "./OwnDriverNameAndStatus"

interface OwnDriverCardProps {
  driver: Driver
  isSelected: boolean
  onClick: () => void
  index: number
}

const OwnDriverCard: React.FC<OwnDriverCardProps> = ({ driver, isSelected, onClick, index }) => {
  return (
    <div
      className={`flex flex-row cursor-pointer rounded-lg border pl-4 pr-5 pointer-events-auto ${
        isSelected ? "card-selected" : ""
      }`}
      onClick={onClick}
      key={index}
    >
      <div
        className="flex flex-row pointer-events-none items-center text-sm w-full select-none justify-between py-2"
        key={driver?.id}
      >
        <OwnDriverNameAndStatus driver={driver} />
        <Image src={vehicleImage(driver?.vehicleType)} priority={true} width={24} height={24} />
      </div>
    </div>
  )
}

export default OwnDriverCard
